import { Grid } from '@material-ui/core'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import Pagination from '../../Pagination/Pagination'
import ProjectCard from '../../Project/ProjectCard'

const ProjectGrid = ({
  projects,
  handleDeleteClick,
  handleEditViewClick,
  handleArchiveClick,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const { userInfo } = useSelector((state) => state.userLogin)

  return (
    <>
      <Grid container spacing={2}>
        {(rowsPerPage > 0
          ? projects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          : projects
        )
          // eslint-disable-next-line array-callback-return
          .map((project, index) => {
            const hideFromUser =
              project.archiveReason === 'User archived project' &&
              !userInfo.isAdmin
            if (!hideFromUser)
              return (
                <Grid key={index} item xs={3}>
                  <ProjectCard
                    project={project}
                    handleDeleteClick={handleDeleteClick}
                    handleEditViewClick={handleEditViewClick}
                    handleArchiveClick={handleArchiveClick}
                  />
                </Grid>
              )
          })}
      </Grid>

      <Pagination
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        rows={projects}
        className="m-t-40"
      />
    </>
  )
}

export default ProjectGrid
